module.exports = __webpack_public_path__ + "static/introduction-f720abef5dc2820e24f90882bd240aa5.jpg";